import { findIndex } from "lodash";

document.addEventListener('readystatechange', () => {

        let container = Array.from(document.getElementsByClassName('wayfinder-block__top'));
        if(container.length < 1) {
            return;
        }
        container = container[0];
        const image = document.querySelector('.wayfinder-block__right');
        const items = container.getElementsByClassName('nav-item');

        Array.from(items).forEach((item, index) => {
            item.addEventListener("mouseover", () => {
                image.style.backgroundImage = `url(${item.dataset.image})`;
            });
        });

});
